import script from "./SubjectSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubjectSettings.vue?vue&type=script&setup=true&lang=ts"

import "./SubjectSettings.vue?vue&type=style&index=0&id=68cc7c05&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68cc7c05"]])

export default __exports__